import React from 'react'
import {Row} from '@modifi/ui'
import {useInputValue} from '@modifi/plugin-forms'
import {
  useInputNameSpecificTranslationKey,
  InputComponent,
  RadioGroupComponent,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON,
  withHideIfNotVisible,
  useRenderPersistedArray,
  InputTooltipInfo,
} from '@modifi/plugin-onboarding'

import {FormInputComponentCol} from '../../../../../plugins/onboarding'
import {TranslateFn} from '../../../../../types/common'

type PoliticallyExposedInputRowProps = {
  t: TranslateFn
}

const PoliticallyExposedInputRow: React.FC<PoliticallyExposedInputRowProps> = ({t}) => {
  const {value} = useInputValue({
    name: BENEFICIAL_OWNER_POLITICALLY_EXPOSED,
    defaultValue: false,
  })
  const inputNameSpecific = useInputNameSpecificTranslationKey()

  const politicallyExposedRadioOptions = useRenderPersistedArray([
    {
      label: t(inputNameSpecific(BENEFICIAL_OWNER_POLITICALLY_EXPOSED, 'value.true')),
      value: true,
      colProps: {
        auto: true,
      },
    },
    {
      label: t(inputNameSpecific(BENEFICIAL_OWNER_POLITICALLY_EXPOSED, 'value.false')),
      value: false,
      colProps: {
        auto: true,
      },
    },
  ])

  return (
    <>
      <Row mb={16}>
        <FormInputComponentCol
          t={t}
          inputName={BENEFICIAL_OWNER_POLITICALLY_EXPOSED}
          inputComponent={RadioGroupComponent}
          options={politicallyExposedRadioOptions}
          inputProps={{
            labelAddition: (
              <InputTooltipInfo inputName={BENEFICIAL_OWNER_POLITICALLY_EXPOSED} t={t} />
            ),
          }}
        />
      </Row>
      {value && (
        <Row>
          <FormInputComponentCol
            t={t}
            inputName={BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON}
            inputComponent={InputComponent}
            inputProps={{
              labelAddition: (
                <InputTooltipInfo inputName={BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON} t={t} />
              ),
            }}
          />
        </Row>
      )}
    </>
  )
}

export default withHideIfNotVisible(
  PoliticallyExposedInputRow,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED
)
